import axios from 'axios'
var config = require('./config.js')
/**
 * 用户登录
 *
 * @param {*} phone_no
 * @param {*} password
 * @param {*} company_name
 * @returns
 */
function userLogin(phone_no, password, company_name) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: '/index.php/RestAPI/TeamBoxWxapp/CustodianLogin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          phone_no: phone_no,
          password: password,
          company_name: company_name
        }
      })
      .then(function (response) {
        console.log(response.data)
        resolve(response.data)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 校验token， 分别调用正式环境和测试环境的校验接口
 *
 * @param {*} password
 * @returns
 */
async function checkToken(password) {
  let checkResult = await prodCheckToken(password);
  if (checkResult.meta.code === 200) {
    // 正式环境校验成功
    console.log('正式环境校验成功');
  }
  else {
    // 正式环境校验失败
    console.log('正式环境校验失败');
    checkResult = await testCheckToken(password);
  }
  return new Promise(function (resolve, reject) {
    resolve(checkResult);
  })
}
  
/**
 * 正式服务器校验token
 * 注意：没有专用的token校验接口，于是用获取所有空间信息来校验token。这个接口属于查询类接口，应该不会对系统造成影响,
 * 并且只有ibox下有分配了空间，所以companyname写死了‘ibox’
 *
 * @param {*} password
 * @returns
 */
function prodCheckToken(password) {
  return new Promise(function (resolve, reject) {
    axios({
      method: 'post',
      url: '/index.php/RestAPI/TeamBoxWxapp/getSpaceList',
      headers: {
        'Content-Type': 'application/json',
        'companyname': 'ibox',
        'password': password
      },
      data: {
      }
    })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 测试服务器校验token
 * 注意：没有专用的token校验接口，于是用获取所有空间信息来校验token。这个接口属于查询类接口，应该不会对系统造成影响,
 * 并且只有ibox下有部署了空间，所以companyname写死了‘xjpt’
 *
 * @param {*} password
 * @returns
 */
function testCheckToken(password) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: '/testServer/index.php/RestAPI/TeamBoxWxapp/getSpaceList',
        headers: {
          'Content-Type': 'application/json',
          'companyname': 'xjpt',
          'password': password
        },
        data: {}
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 设置开门费用
 *
 * @param {*} openCost 开门费用
 */
async function setOpenCost(openCost) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/setOpenCost',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          openCost: openCost
        }
      })
      .then(function (response) {
        // console.log(response)
        resolve(response.data.meta.code)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 获取开门费用
 *
 */
function getOpenCost() {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/getOpenCost',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {}
      })
      .then(function (response) {
        // console.log(response)
        resolve(response.data.body.openCost)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 获取开门记录
 *
 */
function getOpenLog(page) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/getOpenLog',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'page': page
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 同意访客申请
 *
 */
function agreeRequest(data) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.address + '/Bsw/visitRequest',
        // url: 'http://47.106.210.42/init.php',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 拒绝访客申请
 *
 */
function refuseRequest(id) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/refuseRequest',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'id': id
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取访客申请
 *
 */
function getVisitRequest() {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/getVisitRequest',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取访客记录
 *
 */
function getCheckLog(currentPage) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/getCheckLog',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'currentPage': currentPage
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}


/**
 * 获取访客记录
 *
 */
function updateVisitRequest(data) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: 'http://47.107.118.123:8103/bswSpringHotel/updateVisitRequest',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data:data
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export {
    userLogin,
    checkToken,
    setOpenCost,
    getOpenCost,
    getOpenLog,
    agreeRequest,
    refuseRequest,
    getVisitRequest,
    getCheckLog,
    updateVisitRequest
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 